import { differenceInMinutes, isBefore } from "date-fns";

import { parseUtc } from "../../shared/utils/parseUtc";
import { SESSION_STATUS } from "../consts/sessionStatus";
import { SessionStatusBasedOnTime } from "../types/SessionStatusBasedOnTime";

/**
 * Get the session status based on the current time and the session start time.
 * - "upcoming" if the session is in the future,
 * - "late_join" if the session started within the last 10 minutes,
 * - "missed" if the session started between T+10 and T+30,
 * - "ended" if the session started between T and T+10,
 * - "expired" if the session started more than 30 minutes ago.
 * @param sessionStart represents the start time of the session in string format
 * @returns The status of the session based on the current time.
 */

export const sessionStatusBasedOnTime = (
  sessionStart: string,
): SessionStatusBasedOnTime => {
  const sessionDate = parseUtc(sessionStart);
  const now = new Date();

  if (isBefore(now, sessionDate)) {
    return SESSION_STATUS.UPCOMING;
  }

  const minutesDifference = differenceInMinutes(now, sessionDate);

  if (minutesDifference <= 10) {
    return SESSION_STATUS.LATE_JOIN;
  }

  if (minutesDifference > 10 && minutesDifference <= 30) {
    return SESSION_STATUS.MISSED;
  }

  if (minutesDifference > 30 && minutesDifference <= 45) {
    return SESSION_STATUS.ENDED;
  }

  return SESSION_STATUS.EXPIRED;
};
